/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MethodData } from './methodData';


export interface DocumentData { 
    /**
     * The methods applicable to the document.
     */
    methodDatas?: Array<MethodData> | null;
    /**
     * The data payload
     */
    data?: object | null;
    /**
     * The full name of the user holding the lock if the document is locked or null otherwise.
     */
    lockedUserFullName?: string | null;
}

